import React, { Component } from "react";
import { connect } from "react-redux";
import {schema} from './schema';
import { withRouter } from "react-router-dom";
import * as matterActions from "../../components/matter/matterActions";
import * as routes from "../../shared/routes";

class CaseSearchResults extends Component {
  constructor(props){
    super(props);
    this.records = [];
  }
  
  componentDidMount() {
    if(this.props.results && this.props.results.length > 0 && !this.props.loading )
    {
      this.initialiseDataTable(); 
    }
  }

  componentDidUpdate() {
    if(this.props.results && this.props.results.length > 0 && !this.props.loading )
    {
      this.initialiseDataTable(); 
    }
  } 

  onTableAction (table, action, value, rowData, index) {
    if (action === 'viewAction') {      
        this.viewData(value[0].rowData);
    }
  }

  viewData(x)
  {
    this.setMatter(
                  x.reference,
                  x.description,
                  x.isUdModule,
                  x.udModuleUid,
                  x.udModuleName,
                  x.masterProcessName,
                  x.masterProcessId,
                  x.id,
                  x.latestUpdate,
                  x.latestMilestone
                );
    this.props.history.push(routes.caseSummary);
  }

  initialiseDataTable()
  {   
    if(this.props.showClosedMatters){
      schema.properties.archivedDate.hidden = false
    }
    else{
      schema.properties.archivedDate.hidden = true
    }

    const data = () => this.records
    const totalRecords = this.records.length
    var table = document.getElementById('my-data-table')
    const onAction = (table, action, value, rowData, index) => this.onTableAction(table, action, value, rowData, index)

    table.addEventListener('ready', function () {
      table.initialise({
        bordered: true,
        striped: true,
        columnSearch: true,
        schema: schema,
        totalCount: totalRecords,
        data: data,
        onAction
      })
    })  
  }

  setMatter = (reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone) => {
    this.props.onSetMatter(reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone);
  };
  
  render() { 
     if (!this.props.results)
     {
       return <div></div>;
     }
     else{
      this.records= this.props.results.map(x=>
        (
           {
             "id": x.id,
            "reference" : x.reference,
            "description": x.description,
            "openDate": x.openDate,
            "lastUpdated": x.lastUpdatedDate,
            "archivedDate" : x.archivedDate,          
            "isUdModule": x.isUdModule,
            "udModuleUid": x.udModuleUid,
            "udModuleName": x.udModuleName,
            "masterProcessName": x.masterProcessName,
            "masterProcessId": x.masterProcessId,
            "latestUpdate": x.latestUpdate === null ? "N/A" : x.latestUpdate,
            "latestMilestone": x.latestMilestone === null ? "N/A" : x.latestMilestone,
            "LinkForCaseSummary": "View"
          }
        )
      )
 
      return (
        <mosaic-card>
          <mosaic-card-body>
            <mosaic-data-table id="my-data-table"></mosaic-data-table>
          </mosaic-card-body>
        </mosaic-card>
      );
    }
  }
}

const mapStateToProps = state => ({
  token: state.login.token
});

const mapDispatchToProps = dispatch => {
  return {
    onSetMatter: (reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone) =>
      dispatch(matterActions.setMatter(reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone))
  };
};

export default  withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseSearchResults));
